import {gql} from "@irati/utils/gql"

import TenantOnboarding from "../fragments/tenantOnboarding"

const query = gql`
  query getTenantOnboardingList($onboardingFinished: Boolean, $launchManagerId: ID, $cursor: String) {
    getTenantOnboardingList(onboardingFinished: $onboardingFinished, cursor: $cursor, launchManagerId: $launchManagerId) {
      results {
        ...TenantOnboarding
      }
      cursor
      hasMore
    }
  }
  ${TenantOnboarding}
`

export default query
